import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import settings from '../config.js'
import Vue3Signature from "vue3-signature"

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all'

import './assets/css/style.css'

global.app = settings;
createApp(App).use(Vue3Signature).use(store).use(router).mount('#app')
